module.exports = __webpack_public_path__ + "static/media/img_8.d695bb9e.png";